import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import {
  ArrowLeft,
  ChevronRight,
  MapPin,
  Phone,
  MessageCircle,
  Mail,
  Info,
  CheckCircle,
  ArrowUp,
  Clock,
  Search, // Added Search Icon
  Filter  // Added Filter Icon
} from "lucide-react";

const FlashDeals = () => {
  const [data, setData] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [activeCategory, selectedVendor]);


  const [categories, setCategories] = useState([]);
  // New States for Search and Location
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  const [bookingDetails, setBookingDetails] = useState(null);
  const [submitStatus, setSubmitStatus] = useState("idle");
  const [serverError, setServerError] = useState("");

  const closeBtnRef = useRef(null);

  useEffect(() => {
    axios
      .get("https://ezer-eventapp.onrender.com/events")
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {

    axios.get("https://ezer-eventapp.onrender.com/categories")
      .then(res => setCategories(res.data))

  }, [])

  // 👇 AUTO SCROLL TO TOP
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [activeCategory, selectedVendor]);

  const getStartingPrice = (vendor) => {
    let min = Infinity;
    vendor.packages?.forEach(evt => {
      evt.packages?.forEach(pkg => {
        if (pkg.price < min) min = pkg.price;
      });
    });
    return min === Infinity ? 0 : min;
  };

  // --- FILTERING LOGIC ---

  // 1. Get all unique categories
  const allCategories = [...new Set(data.flatMap(item => item.categories))];

  // 2. Get all unique cities for the location dropdown
  const allCities = [...new Set(data.flatMap(v => v.locations?.map(l => l.city) || []))];

  // 3. Filter vendors based on Category + Search + Location
  const filteredVendors = data.filter((vendor) => {
    const matchesCategory = activeCategory ? vendor.categories.includes(activeCategory) : true;

    const matchesSearch =
      vendor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      vendor.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      vendor.packages?.some(pg => pg.eventName.toLowerCase().includes(searchQuery.toLowerCase()));

    const matchesLocation = selectedLocation
      ? vendor.locations?.some(loc => loc.city === selectedLocation)
      : true;

    return matchesCategory && matchesSearch && matchesLocation;
  });

  const submitHandler = (e) => {
    e.preventDefault();
    setSubmitStatus("loading");
    const formData = new FormData(e.target);
    const vendorLoc = selectedVendor?.locations?.length > 0
      ? `${selectedVendor.locations[0].city}, ${selectedVendor.locations[0].state}`
      : "Location not specified";

    const orderData = {
      orderId: `ORD-${Date.now().toString().slice(-6)}`,
      name: formData.get("name"),
      mobile: formData.get("phone"),
      address: `Vendor: ${selectedVendor.name} | Location: ${vendorLoc} | User Msg: ${formData.get("message")}`,
      variants: [{
        id: selectedVendor._id,
        name: bookingDetails.eventName,
        variant: { weight: bookingDetails.packageName, price: bookingDetails.price.toString() },
        qty: 1,
        subtotal: bookingDetails.price
      }],
      total: bookingDetails.price,
      date: new Date().toLocaleString(),
      status: "Pending"
    };

    axios.post("https://ezer-eventapp.onrender.com/orders", orderData)
.then(() => {
  setSubmitStatus("success");

//   const customerName = formData.get("name");
//   const customerPhone = formData.get("phone");

//   const message = `*Thank you for booking with us!* 🎉

// Event: ${bookingDetails.eventName}
// Package: ${bookingDetails.packageName}
// Price: ₹${bookingDetails.price}

// Customer Name: ${customerName}
// Phone: ${customerPhone}

// Our team will contact you as soon as possible to confirm the booking.

// Thank you for choosing us!`;

//   const whatsappNumber = "917893230272"; // country code +91
//   const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

//   window.open(whatsappURL, "_blank");

  setTimeout(() => {
    closeBtnRef.current.click();
    setSubmitStatus("idle");
    e.target.reset();
  }, 2000);
})
      .catch(() => {
        setSubmitStatus("error");
        setServerError("Booking failed");
      });
  };

  return (
    <div className="container py-5 mt-5">
      {/* Navigation & Search Bar Section */}
      <div className="row mb-4 align-items-center">
        <div className="col-md-4">
          {selectedVendor ? (
            <button className="btn btn-light" onClick={() => setSelectedVendor(null)}>
              <ArrowLeft size={16} /> Back to List
            </button>
          ) : activeCategory ? (
            <button className="btn btn-light" onClick={() => setActiveCategory(null)}>
              <ArrowLeft size={16} /> All Categories
            </button>
          ) : null}

          <h2 className="fw-bold mt-2">
            {selectedVendor ? selectedVendor.name : activeCategory ? activeCategory : "Explore Events"}
          </h2>
        </div>

        {/* Search and Location Filters - Hidden when viewing specific vendor detail */}
        {activeCategory && !selectedVendor && (
          <div className="col-md-8">
            <div className="row g-2">
              <div className="col-md-7">
                <div className="input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <Search size={18} className="text-muted" />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0"
                    placeholder="Search by vendor or event name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <MapPin size={18} className="text-muted" />
                  </span>
                  <select
                    className="form-select border-start-0 ps-0"
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                  >
                    <option value="">All Locations</option>
                    {allCities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* CATEGORY VIEW (Main Landing) */}
      {!activeCategory && !selectedVendor && (
        <div className="row">
          {categories.map((cat, index) => (
            <div key={index} className="col-md-3 mb-4">

              <div
                className="card shadow-sm"
                style={{ cursor: "pointer" }}
                onClick={() => setActiveCategory(cat.name)}
              >

                <div
                  id={`categoryCarousel-${index}`}
                  className="carousel slide"
                  data-bs-ride="carousel"
                  data-bs-interval="1500"
                >

                  <div className="carousel-inner">

                    {cat.images?.map((img, i) => (
                      <div
                        key={i}
                        className={`carousel-item ${i === 0 ? "active" : ""}`}
                      >
                        <img
                          src={img}
                          className="d-block w-100"
                          style={{ height: "200px", objectFit: "cover" }}
                          alt="category"
                        />
                      </div>
                    ))}

                  </div>

                  {/* PREVIOUS BUTTON */}

                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target={`#categoryCarousel-${index}`}
                    data-bs-slide="prev"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="carousel-control-prev-icon"></span>
                  </button>

                  {/* NEXT BUTTON */}

                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target={`#categoryCarousel-${index}`}
                    data-bs-slide="next"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="carousel-control-next-icon"></span>
                  </button>

                </div>

                <div className="card-body text-center">
                  <h5>{cat.name}</h5>
                </div>

              </div>

            </div>
          ))}
        </div>
      )}

      {/* VENDOR LIST (Filtered Results) */}
      {activeCategory && !selectedVendor && (
        <div className="row">
          {filteredVendors.length > 0 ? (
            filteredVendors.map((vendor) => (
              <div className="col-md-4 mb-4" key={vendor._id}>
                <div className="card shadow-sm h-100">
                  <div id={`carousel-${vendor._id}`} className="carousel slide" data-bs-ride="carousel">

                    <div className="carousel-inner">

                      {vendor.images?.map((img, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${index === 0 ? "active" : ""}`}
                        >
                          <img
                            src={img}
                            className="d-block w-100"
                            style={{ height: 200, objectFit: "cover" }}
                            alt="vendor"
                          />
                        </div>
                      ))}

                    </div>

                    {/* Left Arrow */}
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target={`#carousel-${vendor._id}`}
                      data-bs-slide="prev"
                    >
                      <span className="carousel-control-prev-icon"></span>
                    </button>

                    {/* Right Arrow */}
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target={`#carousel-${vendor._id}`}
                      data-bs-slide="next"
                    >
                      <span className="carousel-control-next-icon"></span>
                    </button>

                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                      <h5>{vendor.name}</h5>
                      <span className="badge bg-light text-dark border">
                        <MapPin size={12} /> {vendor.locations?.[0]?.city}
                      </span>
                    </div>
                    <p className="small text-muted text-truncate-2">{vendor.description}</p>
                    <h6 className="text-primary">Starts from ₹{getStartingPrice(vendor)}</h6>
                    <button className="btn btn-dark w-100 mt-2" onClick={() => setSelectedVendor(vendor)}>
                      View Packages
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <Info size={48} className="text-muted mb-3" />
              <h4>No vendors found matching your search.</h4>
              <p className="text-muted">Try changing your search terms or location.</p>
              <button className="btn btn-outline-primary" onClick={() => { setSearchQuery(""); setSelectedLocation(""); }}>
                Clear All Filters
              </button>
            </div>
          )}
        </div>
      )}

      {/* VENDOR DETAIL (Same as your original code) */}
      {selectedVendor && (
        <div className="row">
          {/* LEFT */}

          <div className="col-lg-8">

            <div className="mb-4">

              <h5>About</h5>
              <p>{selectedVendor.description}</p>

            </div>

            {/* PACKAGES */}

            {selectedVendor.packages?.map((eventGroup, i) => (

              <div key={i} className="mb-5">

                <h4 className="text-primary mb-3">
                  {eventGroup.eventName} Packages
                </h4>

                <div className="row">

                  {eventGroup.packages.map((pkg, j) => (

                    <div className="col-md-6 mb-3" key={j}>

                      <div className="border rounded p-3 h-100">

                        <h6 className="fw-bold">
                          {pkg.packageName}
                        </h6>

                        <h5 className="text-primary">
                          ₹{pkg.price}
                        </h5>

                        <p className="small">{pkg.description}</p>

                        {/* Duration */}

                        {pkg.duration && (

                          <p className="small text-white">
                            <Clock size={14} /> Duration: {pkg.duration}
                          </p>

                        )}

                        {/* Features */}

                        {pkg.features?.map((f, k) => (

                          <div key={k} className="small">

                            <CheckCircle
                              size={14}
                              className="text-success me-1"
                            />

                            {f}

                          </div>

                        ))}

                        <button
                          className="btn btn-dark w-100 mt-3"
                          data-bs-toggle="modal"
                          data-bs-target="#orderModal"
                          onClick={() =>
                            setBookingDetails({
                              ...pkg,
                              eventName: eventGroup.eventName
                            })
                          }
                        >
                          Book Now
                        </button>

                      </div>

                    </div>

                  ))}

                </div>

              </div>

            ))}

          </div>
          {/* --- ADD THIS MODAL STRUCTURE AT THE BOTTOM --- */}
          <div className="modal fade" id="orderModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Complete Your Booking</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                </div>
                <div className="modal-body">
                  {bookingDetails && (
                    <div className="mb-3 p-2 bg-light rounded">
                      <h6>{bookingDetails.eventName} - <span className="text-primary">{bookingDetails.packageName}</span></h6>
                      <p className="mb-0 fw-bold">Price: ₹{bookingDetails.price}</p>
                    </div>
                  )}

                  <form onSubmit={submitHandler}>
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input type="text" name="name" className="form-control" required placeholder="John Doe" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input type="tel" name="phone" className="form-control" required placeholder="1234567890" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Message (Optional)</label>
                      <textarea name="message" className="form-control" rows="3" placeholder="Any special requirements?"></textarea>
                    </div>

                    {submitStatus === "error" && (
                      <div className="alert alert-danger p-2 small">{serverError}</div>
                    )}

                    {submitStatus === "success" ? (
                      <div className="alert alert-success">Booking Successful! Closing...</div>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-dark w-100"
                        disabled={submitStatus === "loading"}
                      >
                        {submitStatus === "loading" ? "Processing..." : "Confirm Booking"}
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}

          <div className="col-lg-4">

            <div className="card shadow-sm">

              <div className="card-body">

                <h5 className="mb-3">Contact</h5>

                <p>
                  <Info size={16} /> {selectedVendor.contact?.name}
                </p>

                <p>
                  <Phone size={16} /> {selectedVendor.contact?.phone}
                </p>

                <p>
                  <MessageCircle size={16} /> {selectedVendor.contact?.whatsapp}
                </p>

                <p>
                  <Mail size={16} /> {selectedVendor.contact?.email}
                </p>

                <hr />

                <h6 className="mb-3">Locations</h6>

                {selectedVendor.locations?.map((loc, i) => (

                  <div key={i} className="mb-3">

                    <strong>{loc.venue}</strong>

                    <p className="small mb-1">
                      {loc.city}, {loc.state}
                    </p>

                    <p className="small text-muted">
                      {loc.address}
                    </p>

                  </div>

                ))}

                {/* Google Map */}

                {selectedVendor.locations?.[0]?.city && (

                  <iframe
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    loading="lazy"
                    src={`https://maps.google.com/maps?q=${selectedVendor.locations[0].city}&output=embed`}
                  ></iframe>

                )}

              </div>

            </div>

          </div>
        </div>
      )}
      {showArrow && (
        <div
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          }
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            background: "linear-gradient(135deg, #7b2ff7, #8e2fe693)",
            color: "#fff",
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 999,
            boxShadow: "0 6px 15px rgba(0,0,0,0.25)"
          }}
        >
          <ArrowUp size={22} />
        </div>
      )}
    </div>
  );
};

export default FlashDeals;